import { Fieldset, Group, Stack, Switch, TextInput } from '@mantine/core';
import { DateInput } from '@mantine/dates';
import * as React from 'react';

import CustomDropzone from '../../../../../components/CustomDropzone/CustomDropzone';
import LabelText from '../../../../../components/LabelText/LabelText';
import { useI18n } from '../../../../../contexts/I18nProvider';
import { UserPersonalSensitiveDocument } from '../../../../../types/api/payload/user';
import type { UserResponse } from '../../../../../types/api/response/user';
import UserPersonalSensitiveDocumentViewer from '../UserPersonalSensitiveDocumentViewer/UserPersonalSensitiveDocumentViewer';

type Props = {
  form: any;
  disabled: boolean;
  employee: UserResponse;
};

export default function SocialSecurityForm({
  form,
  disabled,
  employee,
}: Props) {
  const { t } = useI18n();
  return (
    <Stack>
      <Switch
        label={<LabelText text={t('w.handicappedWorker')} />}
        labelPosition={'left'}
        checked={form.values.handicappedWorker}
        {...form.getInputProps('handicappedWorker')}
        disabled={disabled}
      />
      <TextInput
        label={<LabelText text={t('w.socialSecurityNumber')} />}
        placeholder={t('w.noValue')}
        {...form.getInputProps('ssNumber')}
        disabled={disabled}
        required={Boolean(employee?.onBoardingId)}
      />
      <Fieldset legend={t('w.vitaleCard')}>
        <Group grow preventGrowOverflow={false} wrap="nowrap">
          <UserPersonalSensitiveDocumentViewer
            userId={employee.id}
            type={UserPersonalSensitiveDocument.securitySocial}
            fileName={t('w.vitaleCard')}
          />
          <CustomDropzone
            onDrop={(files) => form.setFieldValue('ssFiles', files)}
            files={form.values.ssFiles}
            mimeType={'pdf'}
            resetFile={() => form.setFieldValue('ssFiles', [])}
            disabled={disabled}
          />
        </Group>
      </Fieldset>
      <DateInput
        label={<LabelText text={t('w.medicalCheckupDate')} />}
        valueFormat={'D MMMM YYYY'}
        placeholder={t('w.noValue')}
        clearable
        {...form.getInputProps('medicalCheckupDate')}
      />
      <Fieldset legend={t('w.medicalCheckupResultFile')}>
        <Group grow preventGrowOverflow={false} wrap="nowrap">
          <UserPersonalSensitiveDocumentViewer
            userId={employee.id}
            type={UserPersonalSensitiveDocument.medicalCheckupResult}
            fileName={t('w.medicalCheckupResultFile')}
          />
          <CustomDropzone
            onDrop={(files) =>
              form.setFieldValue('medicalCheckupResultFiles', files)
            }
            files={form.values.medicalCheckupResultFiles}
            mimeType={'pdf'}
            resetFile={() =>
              form.setFieldValue('medicalCheckupResultFiles', [])
            }
            disabled={disabled}
          />
        </Group>
      </Fieldset>

      <Fieldset legend={t('w.medicalCheckupFile')}>
        <Group grow preventGrowOverflow={false} wrap="nowrap">
          <UserPersonalSensitiveDocumentViewer
            userId={employee.id}
            type={UserPersonalSensitiveDocument.medicalCheckup}
            fileName={t('w.medicalCheckupFile')}
          />
          <CustomDropzone
            onDrop={(files) => form.setFieldValue('medicalCheckupFiles', files)}
            files={form.values.medicalCheckupFiles}
            mimeType={'pdf'}
            resetFile={() => form.setFieldValue('medicalCheckupFiles', [])}
            disabled={disabled}
          />
        </Group>
      </Fieldset>
    </Stack>
  );
}
